import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
`

export const Label = styled.p`
  font-family: 'PT Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.43;
  color: #757575;
  margin-bottom: 4px;
`

export const StatusRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
  cursor: default;

  svg {
    color: #d48806;
    font-size: 12px;
    line-height: 16px;
    width: 16px;
    text-align: center;
  }
`

export const StatusText = styled.span`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #8f5b00;
  white-space: nowrap;
`

export const TooltipTitle = styled.div`
  text-align: center;
  font-family: Roboto, sans-serif;
`

export const ViewButton = styled.button<{ $inline?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: ${({ $inline }) => ($inline ? '0' : '2px')};
  padding: 0;
  border: none;
  background: transparent;
  color: #0085ff;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  cursor: pointer;
  transition: opacity 200ms;

  &:hover:not(:disabled) {
    opacity: 0.7;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`
